import {Component, ViewChild} from '@angular/core';

import {AlertController, App, NavController, Toast, ToastController} from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {HomePage} from "../../home/home";

import { DatePickerModule } from 'ion-datepicker';
import { DatePickerDirective } from 'ion-datepicker';
import * as moment from 'moment';
import * as _ from "lodash";

@Component({
    selector: 'page-identity',
    templateUrl: 'identity.html'
})
export class IdentityPage {
    username: string;
    countryList: any;
    identityRef: any;
    identityData: any;
    identityForm : FormGroup;
    submitAttempt: boolean = false;

    zipcodeCompletor:any;

    browserMode: boolean = false;
    maxVisitDate: Date;

    @ViewChild(DatePickerDirective) private datepickerDirective:DatePickerDirective;

    constructor(
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public afDatabase: AngularFireDatabase,
        private formBuilder: FormBuilder,
        public app: App,
        public toastCtrl: ToastController
    ) {
        //userData.setToken('nova4');
        this.identityForm = this.formBuilder.group({
            situation: ['', Validators.required],
            nationalite: [null, Validators.required],
            paysn: [null, Validators.required],
            deptn: [null, Validators.required],
            villen: [null, Validators.required],
            secu: [null, [Validators.required, this.secuValidator.bind(this) ]],
            last_visit: [null, Validators.required],
        });
        this.maxVisitDate = new Date();
        this.browserMode = this.uiData.isBrowser();


    }
    back(event)
    {

        try{
            this.app.getRootNav().setRoot(HomePage);
            this.app.getRootNav().popToRoot();
        }catch(e){}
    }
    secuValidator(control: FormControl): {[s: string]: boolean} {
        if (control.value && control.value.length < 15) {
            return {invalidSecu: true};
        }
        if (control.value && control.value.length > 15) {
            return {invalidSecu: true};
        }
    }
    ngAfterViewInit() {
        this.identityData = {
            situation : '',
            description : '',
            nationalite : 'Français',
            villen : '',
            deptn : '',
            paysn : 'FR',
            secu : '',
            last_visit: ''
        }
        ;
        this.countryList = this.uiData.countryList();
        var that = this;
        this.userData.load().subscribe(data => {
            if(!data.identity || !data.identity.secu )
            {
                that.userData.set('identity',that.identityData);
            }
            that.identityData = that.userData.get('identity');
            //console.log(that.identityData.last_visit);
            if(!that.identityData.last_visit || that.identityData.last_visit=="2000-01-01")
            {
                that.identityData.no_visit = true;
            }
        });
        /*this.userData.getUserDbReference('identity').valueChanges().subscribe(data => {
            if(!data)
            {
                that.userData.getUserDbReference('identity').set(that.identityData);
            }
            that.identityData = data;
        });*/
        /*this.userData.getToken().then(function(token){
            that.identityRef = that.afDatabase.object('/users/'+token+'/identity');
            that.identityRef.valueChanges().subscribe(data => {
                if(!data)
                {
                    that.identityRef.set(that.identityData);
                }
                that.identityData = data;
            });
        });*/

    }

    saveIdentity() {
        this.submitAttempt=true;
        var that = this;
        if(that.identityData.no_visit)that.identityData.last_visit="2000-01-01";
        if(this.identityForm.valid)
        {
            let prompt = this.alertCtrl.create({
                title: 'Confirmation des informations',
                message: that.uiData.getDataValidationWarning(),
                buttons: [
                    {
                        text: 'Oui',
                        handler: data => {
                            that.userData.set('identity',that.identityData);
                            //that.app.getRootNav().setRoot('HomePage');
                            that.toastSuccess("Vos informations ont été enregistrées.");
                        }
                    },
                    {
                        text: 'Annuler',
                        handler: data => {

                        }
                    }
                ]
            });
            prompt.present();
        }
        else
        {
            //console.log(this.identityForm.value);
        }

    }
    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 2000,
            position: 'bottom',
            closeButtonText:'Ok'
        });
        toast.present();
    }
    @ViewChild('secu') secu ;
    secuClick(){
        this.secu.setFocus();
    }

    swipe(event)
    {
        if(event.direction === 2) {
            this.nav.parent.select(3);
        }
        if(event.direction === 4) {
            this.nav.parent.select(1);
        }
    }

    datePick(e){
        var m = moment(e);
        this.identityData.last_visit = m.format('YYYY-MM-DD');
    }
    dateFocus(){
        this.datepickerDirective._click(null);
        //console.log('focus');
    }
    lastVisitDate(){
        if(this.identityData.last_visit)
        {
            return new Date(this.identityData.last_visit);
        }
        else
        {
            return new Date();
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/identity/identity.ts